import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
// import { OG_IMAGE_TYPES, OGImage } from "../og-image";

const MetaTagsReviews = () => {
    const baseUrl = `${appUrl()}/reviews/`;
    const metaTitle = "Reviews";
    const metaDescription = "";
    const metaKeywords = "";

    const commonSchemaContent = {
        "@context": "https://schema.org/",
        "@id": "https://www.cars24.com/",
        "url": "https://www.cars24.com/",
        "name": "CARS24"
    };

    const script = [
        {
            type: "application/ld+json",
            innerHTML: JSON.stringify({
                "@type": "WebPage",
                ...commonSchemaContent
            })
        },
        {
            type: "application/ld+json",
            innerHTML: JSON.stringify({
                "@type": "Website",
                ...commonSchemaContent
            })
        }
    ];

    return (
        <React.Fragment>
            <Helmet script={script}>
                <title>{metaTitle}</title>
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={metaKeywords} />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content={`${baseUrl}`} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="CARS24" />
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
                <link href={`${baseUrl}`} rel="canonical" />
            </Helmet>
            {/* <OGImage type={OG_IMAGE_TYPES.buycar} /> */}
        </React.Fragment>
    );
};

export default MetaTagsReviews;
